import {makeAutoObservable, observable} from 'mobx'
import {UUID} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {PermissionsChecker} from '@client/permissions-checker'
import {createUseStore} from '@containers/hooks'
import {ChatUtils} from '@extensions/chat-utils'
import {globals} from '@extensions/globals-base'
import {PageService} from '@extensions/page-service'

interface State {
  statsOpen: boolean
  boardId?: DataObjectId
}

export class ProjectStore {
  state: State

  private locationListener: UUID

  constructor() {
    this.state = {
      statsOpen: false
    }

    makeAutoObservable(
      this,
      {
        state: observable.shallow
      },
      {autoBind: true}
    )

    globals.openStats = () => {
      this.state.statsOpen = true
      ChatUtils.closeChatIfOpened()
    }

    globals.closeStats = () => {
      this.state.statsOpen = false
    }
  }

  syncOnNew(): void {
    this.locationListener = PageService.addLocationListener(
      this.updateCurrentProject
    )
    this.updateCurrentProject()
  }

  updateCurrentProject(): void {
    const board = PageService.getCurrentBoard()
    this.state.boardId = board?.id
    if (
      PageService.getCurrentProject() &&
      !PermissionsChecker.checkShow(
        'ignore-departments',
        PageService.getCurrentProject(),
        {}
      ) &&
      !PermissionsChecker.isAdmin()
    ) {
      PageService.goTo('board')
    }
  }

  dispose(): void {
    PageService.removeLocationListener(this.locationListener)
  }
}

export const [ProjectContext, useProjectStore] = createUseStore(ProjectStore)
